export default __webpack_public_path__ + "static/media/991.54b742e2.png";